import React, { Fragment } from "react";
import {
    Accordion,
    Button,
    Card,
    Col,
    Form,
    FormCheck,
    InputGroup,
} from "react-bootstrap";
import styles from "../../RetailerWidgetSettings.module.scss";

const RetailerWidgetConfigurationFormView = ({
    handleSubmit,
    values,
    handleChange,
    isSubmitting,
}) => {
    return (
        <Accordion>
            <Accordion.Toggle
                className={styles.accordionToggle}
                as={Card.Header}
                eventKey="0"
            >
                Button Configuration <i className="bi bi-chevron-down"></i>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
                <Form onSubmit={handleSubmit}>
                    <Form.Row>
                        <Col md={4}>
                            {/* <Form.Group>
                                <FormCheck
                                    custom
                                    type="checkbox"
                                    id="captcha"
                                    label="Show captcha"
                                    checked={values.captcha}
                                    name={`captcha`}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Form.Group controlId="questionnaireHeader">
                                <Form.Label>Questionnaire header</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="questionnaireHeader"
                                    value={values.questionnaireHeader}
                                    placeholder="Welcome to Kurt Lyle! Discounts every day!"
                                    onChange={handleChange}
                                />
                            </Form.Group> */}

                            <Form.Group>
                                <FormCheck
                                    custom
                                    type="checkbox"
                                    id="isMultiStoreInventoryOn"
                                    label="Should Tote consider inventory of close by stores"
                                    checked={values.isMultiStoreInventoryOn}
                                    name={`isMultiStoreInventoryOn`}
                                    onChange={handleChange}
                                />
                                {values.isMultiStoreInventoryOn ? (
                                    <Fragment>
                                        <Form.Label htmlFor="multiStoreInventoryRadius">
                                            The radius in which to consider
                                            inventory of stores
                                        </Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type="number"
                                                min="0"
                                                step="1"
                                                name={
                                                    "multiStoreInventoryRadius"
                                                }
                                                id="multiStoreInventoryRadius"
                                                value={
                                                    values.multiStoreInventoryRadius
                                                }
                                                onChange={handleChange}
                                                disabled={
                                                    !values.isMultiStoreInventoryOn
                                                }
                                                style={{
                                                    textAlign: "center",
                                                    width: "100px",
                                                    flexGrow: 0,
                                                }}
                                            />
                                            <InputGroup.Append>
                                                <InputGroup.Text>
                                                    miles
                                                </InputGroup.Text>
                                            </InputGroup.Append>
                                        </InputGroup>
                                    </Fragment>
                                ) : null}
                            </Form.Group>
                            <Form.Group>
                                <FormCheck
                                    custom
                                    type="checkbox"
                                    id="isOnlyOnSpecificPages"
                                    label="Show button on specific pages only"
                                    checked={values.isOnlyOnSpecificPages}
                                    name={`isOnlyOnSpecificPages`}
                                    onChange={handleChange}
                                />
                                {values.isOnlyOnSpecificPages ? (
                                    <Fragment>
                                        <Form.Label htmlFor="allowedPages">
                                            Button Pages
                                        </Form.Label>
                                        <Form.Text muted>
                                            You can add the page url where you
                                            would like the button to appear. You
                                            can also add multiple pages
                                            separated by a comma
                                            (/example,/example2)
                                        </Form.Text>
                                        <Form.Control
                                            type="text"
                                            id="allowedPages"
                                            name="allowedPages"
                                            value={values.allowedPages}
                                            placeholder="/example"
                                            onChange={handleChange}
                                            disabled={
                                                !values.isOnlyOnSpecificPages
                                            }
                                        />
                                    </Fragment>
                                ) : null}
                            </Form.Group>
                            <Form.Group>
                                <FormCheck
                                    custom
                                    type="checkbox"
                                    id="isHiddenOnSpecificPages"
                                    label="Hide button on specific pages"
                                    checked={values.isHiddenOnSpecificPages}
                                    name={`isHiddenOnSpecificPages`}
                                    onChange={handleChange}
                                />
                                {values.isHiddenOnSpecificPages ? (
                                    <Fragment>
                                        <Form.Label htmlFor="disallowedPages">
                                            Hide button on following pages
                                        </Form.Label>
                                        <Form.Text muted>
                                            You can add the page url where you
                                            would like the button to be hidden.
                                            You can also add multiple pages
                                            separated by a comma
                                            (/example,/example2)
                                        </Form.Text>
                                        <Form.Control
                                            type="text"
                                            id="disallowedPages"
                                            name="disallowedPages"
                                            value={values.disallowedPages}
                                            placeholder="/example"
                                            onChange={handleChange}
                                            disabled={
                                                !values.isHiddenOnSpecificPages
                                            }
                                        />
                                    </Fragment>
                                ) : null}
                            </Form.Group>
                            <Form.Group>
                                <FormCheck
                                    custom
                                    type="checkbox"
                                    id="customerAddressMode"
                                    label="Turn on customer address mode"
                                    checked={values.customerAddressMode}
                                    name={`customerAddressMode`}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Form.Group>
                                <FormCheck
                                    custom
                                    type="checkbox"
                                    id="isEducationHidden"
                                    label="Should education screen be hidden"
                                    checked={values.isEducationHidden}
                                    name={`isEducationHidden`}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Form.Group>
                                <FormCheck
                                    custom
                                    type="checkbox"
                                    id="isVisibleOnlyWithItemsInCart"
                                    label="Should button be hidden until items are added to Fitting Room"
                                    checked={
                                        values.isVisibleOnlyWithItemsInCart
                                    }
                                    name={`isVisibleOnlyWithItemsInCart`}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Form.Group>
                                <FormCheck
                                    custom
                                    type="checkbox"
                                    id="isItemsRecommendationOptionOn"
                                    label="Would you like to give your shoppers the ability to opt in to recommendations from your in store staff."
                                    checked={
                                        values.isItemsRecommendationOptionOn
                                    }
                                    name={`isItemsRecommendationOptionOn`}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Form.Group>
                                <FormCheck
                                    custom
                                    type="checkbox"
                                    id="shouldIgnoreSpecificProductTypesInventoryCheck"
                                    label="Should Tote ignore inventory check for specific product types"
                                    checked={
                                        values.shouldIgnoreSpecificProductTypesInventoryCheck
                                    }
                                    name={`shouldIgnoreSpecificProductTypesInventoryCheck`}
                                    onChange={handleChange}
                                />
                                {values.shouldIgnoreSpecificProductTypesInventoryCheck ? (
                                    <Fragment>
                                        <Form.Text muted>
                                            You can add the product type which
                                            you would like the Tote to ignore
                                            inventory for. You can also add
                                            multiple product types separated by
                                            a comma (productType1,productType2)
                                        </Form.Text>
                                        <Form.Control
                                            type="text"
                                            id="productTypesToIgnoreInventoryCheck"
                                            name="productTypesToIgnoreInventoryCheck"
                                            value={
                                                values.productTypesToIgnoreInventoryCheck
                                            }
                                            placeholder="jackets"
                                            onChange={handleChange}
                                            disabled={
                                                !values.shouldIgnoreSpecificProductTypesInventoryCheck
                                            }
                                        />
                                    </Fragment>
                                ) : null}
                            </Form.Group>
                            <Form.Group>
                                <FormCheck
                                    custom
                                    type="checkbox"
                                    id="isRecommendationsEnabled"
                                    label="Should shopper receive recommendations when booking an appointment"
                                    checked={values.isRecommendationsEnabled}
                                    name={`isRecommendationsEnabled`}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Form.Group>
                                <FormCheck
                                    custom
                                    type="checkbox"
                                    id="geofencing"
                                    label="Geofencing"
                                    checked={values.geofencing}
                                    name={`geofencing`}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Form.Row>
                    <Button type="submit" disabled={isSubmitting}>
                        Save
                    </Button>
                </Form>
            </Accordion.Collapse>
        </Accordion>
    );
};

export default RetailerWidgetConfigurationFormView;
